<template lang="html">
<d-row class="justify-content-end mb-4">
  <d-col cols="4" v-for="(total, index) in totals" :key="index">
    <label>{{ labels[index] }}</label>
    <d-card class="px-3 py-5">
      <h5 class="text-right font-weight-bold m-0">{{ total }}</h5>
    </d-card>
  </d-col>
</d-row>

</template>

<script>
import { TOTAL_ITEMS } from './ReportModel';

export default {
  name: 'report-total',
  props: {
    totals: {
      type: Object,
      default: TOTAL_ITEMS,
    },
  },
  data() {
    return {
      labels: {
        total_cash: 'Total à vista',
        total_term: 'Total à prazo',
        grand_total: 'Total geral',
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

</style>
